import Vue from "vue";
import Vuex from "vuex";
import router from '../main';
import general from "./modules/general.js";
import { checkPermisos } from '../routes/subscription-routes';

import Axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    general,
  },

  state: {
    //JWT TOKEN
    xjwt: "",
    //API BASE DE DATOS
    xapiUrl: "",
    //ID DEL TPV
    xidTpv: 0,
    //LIST TPV
    xlistTpv: [],
    //ID DEL NEGOCIO
    xidBusiness: 0,
    //LIST NEGOCIOS
    xlistBusiness: [],

    //IDS TPV FILTRO
    xlistIdsTpv: [],

    //LIST FILTRO TPVS
    xlistIdsTpvFiltro: [],

    //LIST SECTORES
    listaSectores: [],

    //SECTORES
    sectores: false,

    //FECHA DESDE
    xFechaDesde: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),

    //FECHA HASTA
    xFechaHasta: new Date().toISOString(),

    //Respuesta
    xRespuesta: false,



    //NOTIFICACIONES
    xNotificaciones: false,

    xListNovedades: 0,
    xuser: {},
    entorno: "P",
    premiumProfile: false,

    //* temporal Selfi
    esSelfi: false,
    permiso: true,

    //* Config de usuario 133 "developerView": null hasta que la API responde.
    //* Se carga al entrar en el dashboard (DashboardLayout) y la leen las pantallas
    //* con secciones en desarrollo (informes nuevos, integraciones...).
    developerView: null,

    //* Restriccion 84 "solo informe de turnos": la carga el guard de routes/solo-turnos.js
    //* antes de cada navegacion; con ella el layout solo muestra ese informe.
    soloTurnos: false
  },
  mutations: {

    changeJwt(state, jwt) {
      state.xjwt = jwt;
    },
    changeEsSelfi(state, parameter) {
      state.esSelfi = parameter;
    },
    changeEntorno(state, entorno) {
      state.entorno = entorno;
    },
    changeUser(state, user) {
      state.xuser = user;
      state.premiumProfile = user.isPremium == "1";
    },
    changeNotificaciones(state, notificaciones) {
      state.xNotificaciones = notificaciones;
    },
    changeListNovedades(state, novedades) {
      state.xListNovedades = novedades;
    },
    changeApiUrl(state, apiUrl) {
      state.xapiUrl = apiUrl;
    },
    changeListaSectores(state, sectores) {
      state.listaSectores = sectores;
    },
    changeSectores(state, parameter) {
      state.sectores = parameter;
    },
    changeTpv(state, xIdTpv) {
      state.xidTpv = xIdTpv;
    },
    changeBusiness(state, xIdBusiness) {
      state.xidBusiness = xIdBusiness;
    },
    loadListBusiness(state, xListBusiness) {
      state.xlistBusiness = xListBusiness;

      checkPermisos(router.history.current);
    },

    updateBusinessStatus(state, { id, statusVerifactu }) {
      const idx = state.xlistBusiness.findIndex(b => b.id === id);
      if (idx !== -1) {
        Vue.set(state.xlistBusiness, idx, {
          ...state.xlistBusiness[idx],
          statusVerifactu
        });
      }
    },

    changeFechaDesde(state, xFechaFrom) {
      state.xFechaDesde = xFechaFrom;
    },
    changeFechaHasta(state, xFechaTo) {
      state.xFechaHasta = xFechaTo;
    },
    loadListTpvs(state, xlistTpv) {
      state.xlistTpv = xlistTpv;
    },
    loadListIdsTpv(state, xlistIds) {
      state.xlistIdsTpv = [];

      state.xlistIdsTpvFiltro = [];

      xlistIds.forEach(function(x) {
        state.xlistIdsTpv.push(x.id);
        state.xlistIdsTpvFiltro.push(x);
      });
    },

    asignarIdTpv(state, idTpv) {
      state.xlistIdsTpv = idTpv;
    },
    changeRespuesta(state, respuesta) {
      state.xRespuesta = respuesta;
    },
    changePermiso(state, permiso) {
      state.permiso = permiso;
    },
    changeDeveloperView(state, valor) {
      state.developerView = valor;
    },
    changeSoloTurnos(state, valor) {
      state.soloTurnos = valor;
    },
  },
  actions: {
    //* Pregunta una sola vez si el usuario tiene la config 133 developerView
    cargarDeveloperView: function({ commit, state }) {
      let config = {
        params: {
          jwt: state.xjwt,
          idConfig: 133,
        },
        headers: { Authorization: "Bearer " + state.xjwt },
      };

      return Axios.get(state.xapiUrl + "general/getDeveloperModePermission", config)
        .then(function(response) {
          commit("changeDeveloperView", !!(response.data && response.data.permission));
        })
        .catch(function(error) {
          console.log(error);
          commit("changeDeveloperView", false);
        });
    },

    cargarSelfi: function({ commit, dispatch, state }) {
      //* Decodificar en base64 para saber el valor de esSelfi
      try {
        const base64Url = state.xjwt.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const decodedJWT = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function(c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );

        // Parsea el JSON decodificado para obtener un objeto JavaScript porque necesito el bool
        const jwtObject = JSON.parse(decodedJWT);

        // Accede a la propiedad esSelfi
        let esSelfi = jwtObject.esSelfi;

        if (esSelfi) {
          commit("changeEsSelfi", true);
        } else {
          commit("changeEsSelfi", false);
        }
      } catch (error) {
        console.error("Error al decodificar el token JWT:", error.message);
      }
    },

    cargarSectores: function({ commit, dispatch, state }) {
      let config = {
        params: {
          jwt: state.xjwt,
        },
        headers: { Authorization: "Bearer " + state.xjwt },
      };

      Axios.get(state.xapiUrl + "general/getBusinessesSectors", config)
        .then(function(response) {
          if (response.data.response) {
            commit("changeSectores", true);

            response.data.result["sectores"].forEach((sector) => {
              sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
              sector.id = parseInt(sector.id);
            });

            // console.log(response.data.result);
            commit("changeListaSectores", response.data.result["sectores"]);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    cargarBusiness: function({ commit, dispatch, state }) {
      let config = {
        params: {
          jwt: state.xjwt,
        },
        headers: { Authorization: "Bearer " + state.xjwt },
      };

      Axios.get(state.xapiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (response.data.response) {
            commit("changeBusiness", response.data.result[0].id);

            commit("loadListBusiness", response.data.result);

            dispatch("cargarTpvs");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    cargarTpvs: function({ commit, state }) {
      let config = {
        params: {
          idBusiness: state.xidBusiness,
          jwt: state.xjwt,
        },
        headers: { Authorization: "Bearer " + state.xjwt },
      };

      Axios.get(state.xapiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            let xListTpv = [];

            let xListTpvIds = [];

            let xObj = {
              id: "0",
              nameShow: "Todos",
            };
            xListTpv.unshift(xObj);

            response.data.result.forEach(function(x) {
              xListTpv.push(x);
              xListTpvIds.push(x);
            });

            commit("changeTpv", "0");
            commit("loadListTpvs", xListTpv);
            commit("loadListIdsTpv", xListTpvIds);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    cargarNotificaciones: function({ commit, dispatch, state }) {
      let config = {
        params: {
          jwt: state.xjwt,
        },
        headers: { Authorization: "Bearer " + state.xjwt },
      };

      Axios.get(state.xapiUrl + "novedades/getNovedadesByUser", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result.novedadesNoVistas > 0) {
              commit("changeNotificaciones", true);
              commit(
                "changeListNovedades",
                response.data.result.novedadesNoVistas
              );
            } else {
              commit("changeNotificaciones", false);
              commit("changeListNovedades", 0);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js